import React, { useState, useEffect } from 'react';
import './BotStatus.css';

function SyncProgress({ active, progress, message, onComplete }) {
  if (!active) return null;

  const pct = typeof progress === 'number' ? Math.min(100, Math.max(0, progress)) : 0;

  return (
    <div className="sync-progress">
      <div className="sync-progress-bar-track">
        <div className="sync-progress-bar-fill" style={{ width: `${pct}%` }} />
      </div>
      <span className="sync-progress-text">{message || 'Syncing...'}</span>
      {onComplete && (
        <button className="sync-progress-cancel" onClick={onComplete}>
          ✕
        </button>
      )}
    </div>
  );
}

export default SyncProgress;
